import { RootState } from "../../../utils/types/root-state";

export const getOrderState = (state: RootState) => state.order;